 /* global window:true */

import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import ReactGA from 'react-ga';

import Loading from '../components/Loading';
import ProductItem from '../components/ProductItem';

const TITLE = 'Clever Tykes Shop';

class ShopPage extends Component {
    componentDidMount() {
        const { actions } = this.props;

        // set breadcrumb
        actions.setBreadcrumb([{ title: TITLE }]);

        // load products
        actions.productsRequest();

        // log analytics
        ReactGA.pageview(window.location.pathname);
        ReactGA.event({
            category: 'Shop',
            action: 'Visited shop'
        });
    }

    render() {
        const { products, productsState } = this.props;
        // console.log('books', books);

        if (productsState.isFetching && products.length === 0) {
            return <Loading />;
        }

        return (
            <div className="grid-content">
                <Helmet title={TITLE} />
                <div className="container shop">
                    <div className="section-name index-1 container">
                        <div className="col-md-12 resources-title">
                            <h1>{TITLE}</h1>
                            <div className="sep" />
                            <br /><br />
                        </div>
                    </div>

                    <div className="grid-items">
                        <div className="row">
                            {products.length === 0 ?
                                <p>No products found</p>
                                :
                                    products.map(product => <ProductItem key={product.id} product={product} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ShopPage.propTypes = {
    actions: PropTypes.object,
    productsState: PropTypes.object,
    products: PropTypes.array
};

export default ShopPage;



/** WEBPACK FOOTER **
 ** ./src/pages/ShopPage.js
 **/